module.exports = __webpack_public_path__ + "static/media/Eva Everett Headshot_1723797159692.5a802244.jpeg";